export default __webpack_public_path__ + "static/media/icon-aide.f633f2e0.svg";